// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body,html{overflow-x:hidden}.index-continer{position:relative}.fixed-bar{position:sticky;position:-webkit-sticky;top:6em}.main-container{background-color:#f7f7f8;overflow:hidden;padding:80px 0 0!important}.breadcrumbs-link a{text-decoration:none!important}.v-btn:not(.v-btn--round).v-size--default{border-radius:6px!important;height:auto!important;min-height:40px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
